var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pinch-zoom',{attrs:{"backgroundColor":"transparent"}},[_c('img',{staticClass:"px-4 py-10",attrs:{"src":"/static/img/30/asztal.png"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }